import evaluateBlockDependencies from "./evaluateBlockDependencies";
import getExpressionConfiguration from "./getExpressionConfiguration";
import {getActive} from "./getActive";

const checkIfOptionIsVisible = (option, context, user, value) => {

  if (!getActive(option, context)) {
    return false;
  }
  const dependencies = getExpressionConfiguration(option, context, 'dependencies');

  if (
    dependencies?.length &&
    !evaluateBlockDependencies(dependencies, context)
  ) {
    return false;
  }

  const role = context.rolePreview ? context.rolePreview : user['role_type']
  if (option.id.toString() === value) {
    return true
  }
  return !(option?.hidden_question?.length &&
    option.hidden_question.includes(`role_type_${role}`));

};

export default checkIfOptionIsVisible;
